import "@hotwired/turbo-rails"

import "@rails/actiontext"
import "@rails/request.js"

import "@hotwired/turbo-rails"
import "./legacy/auto_theme"
import Rails from "@rails/ujs"


Rails.start()

import {Popover} from 'bootstrap';

import { application } from "./controllers/application"

import SignInController from "./controllers/sign_in_controller"
application.register("sign-in", SignInController)
